// extracted by mini-css-extract-plugin
export default {"card":"l6-z"};